// extracted by mini-css-extract-plugin
export var cardIcon = "_b7-4";
export var checkboxCard = "_b7-0";
export var checkboxCardSelected = "_b7-3";
export var disabled = "_b7-1";
export var outerBorder = "_b7-2";
export var spacerMedium = "_b7-7";
export var spacerSmall = "_b7-6";
export var spacerXsmall = "_b7-5";